<template>
  <div id="lti-grey-screen">
    <div
      v-if="(
        simpleDashType === 'lti'
        && (
          !userDataLoaded
          && contentMigartionConditional
        )
      )"
      id="lti-loader"
    >
      <v-progress-circular
        color="white"
        indeterminate
        size="70"
        :width="5"
      >
      </v-progress-circular>
    </div>
    <div
      v-if="(
        simpleDashType === 'lti'
        && userDataLoaded
      )"
      id="lti"
    >
      <v-alert
        id="lti-alert"
        type="warning"
        v-model="simpleDashData.alert"
      >
        <span style="color: white; font-size: 1.3rem">{{ simpleDashData.alertText }}</span>
      </v-alert>
      <h1
        id="lti-title"
        v-if="simpleDashData.title"
      >
        {{ simpleDashData.title }}
      </h1>
      <p
        v-if="simpleDashData.msg"
        id="lti-msg"
      >
        {{ simpleDashData.msg }}.
      </p>
      <!-- Show this message for MSU if they haven't linked a content item -->
      <p
        v-if="isMSU && !LTIdata.contentId"
        id="lti-msu-msg"
      >
        {{ MSUAlertMessage }}
      </p>
      <p
        v-if="simpleDashData.submsg"
        id="lti-submsg"
      >
        {{ simpleDashData.submsg }}
      </p>
      <!--action buttons for unlinked bulb-->
      <div
        v-if="simpleDashData.primary === 'setLink'"
        class="lti-actions"
      >
        <v-btn
          v-if="simpleDashData.secondary"
          text
          id="lti-secondary"
          @click="ltiAction(simpleDashData.secondarylink)"
          :disabled="simpleDashLoading"
          :loading="simpleDashLoading"
        >
          <span>{{ simpleDashData.secondary }}</span>
        </v-btn>
        <v-btn
          v-if="(
            simpleDashData.primary
            && LTIdata.render_path !== 'broadcast2'
          )"
          id="lti-primary"
          @click="ltiAction(simpleDashData.primarylink)"
          :disabled="simpleDashLoading"
          :loading="simpleDashLoading"
        >
          <span>Set Link</span>
          <v-icon
            v-if="simpleDashData.primaryicon"
            class="text-white"
            style="padding-left: 8px"
          >
            {{ simpleDashData.primaryicon }}
          </v-icon>
        </v-btn>
      </div>
      <!-- We actually don't support this flow anymore...  -->
      <!--action buttons for re-linking bulbs-->
      <!-- <div
        class="lti-actions"
        v-if="simpleDashData.primary === 'RE-LINK'"
      >
        <v-btn
          v-if="simpleDashData.secondary"
          text
          id="lti-secondary"
          @click="ltiAction(simpleDashData.secondarylink)"
          :disabled="simpleDashLoading"
          :loading="simpleDashLoading"
        >
          <span>{{ simpleDashData.secondary }}</span>
        </v-btn>
        <v-btn
          v-if="simpleDashData.primary"
          id="lti-primary"
          @click="ltiAction(simpleDashData.primarylink)"
          :disabled="simpleDashLoading"
          :loading="simpleDashLoading"
        >
          <span>{{ simpleDashData.primary }}</span>
          <v-icon
            v-if="simpleDashData.primaryicon"
            class="text-white"
            style="padding-left: 8px"
            >{{ simpleDashData.primaryicon }}</v-icon
          >
        </v-btn>
      </div> -->
      <!-- basic launch unlink  -->
      <div
        class="lti-actions"
        v-if="
          simpleDashData.primaryLink === 'unlinkOther' &&
          simpleDashData.secondaryLink === 'unlinkLearnMore'
        "
      >
        <v-btn
          text
          id="lti-secondary"
          @click="ltiAction(simpleDashData.secondaryLink)"
          >{{ simpleDashData.secondary }}</v-btn
        >
        <v-btn
          class="white--text"
          id="lti-primary"
          @click="ltiAction(simpleDashData.primaryLink)"
          >{{ simpleDashData.primary }}</v-btn
        >
      </div>
      <!--action buttons for linked bulb with play or student made-->
      <div
        class="lti-actions"
        v-if="(
          simpleDashData.primary === 'Monitor'
          && (
            LTIdata.render_path === 'play2'
            || LTIdata.render_path === 'studentmade2'
          )
        )"
      >
        <v-btn
          v-if="(
            simpleDashData.tertiary
            && LTIdata.render_path === 'play2'
          )"
          text
          id="lti-secondary"
          @click="ltiAction(simpleDashData.tertiarylink)"
          :disabled="simpleDashLoading"
        >
          <span>{{ simpleDashData.tertiary }}</span>
        </v-btn>
        <v-btn
          v-if="
            simpleDashData.secondary && LTIdata.render_path !== 'studentmade2'
          "
          text
          id="lti-secondary"
          @click="ltiAction(simpleDashData.secondarylink)"
          :disabled="simpleDashLoading"
          :loading="simpleDashLoading"
        >
          <span>{{ simpleDashData.secondary }}</span>
        </v-btn>
        <v-btn
          v-if="LTIdata.render_path === 'studentmade2' && LTIdata.groupSetId"
          text
          id="lti-secondary"
          @click="manageGroups"
          :disabled="simpleDashLoading"
          :loading="simpleDashLoading"
        >
          <span>Manage Groups</span>
        </v-btn>
        <v-btn
          v-if="simpleDashData.primary"
          id="lti-primary"
          @click="ltiAction(simpleDashData.primarylink)"
          :disabled="simpleDashLoading"
          :loading="simpleDashLoading"
        >
          <span>{{ simpleDashData.primary }}</span>
          <v-icon
            v-if="simpleDashData.primaryicon"
            class="text-white"
            style="padding-left: 8px"
            >{{ simpleDashData.primaryicon }}</v-icon
          >
        </v-btn>
      </div>
      <!--action buttons for linked bulb with broadcast-->
      <div
        v-if="(
          simpleDashData.primary === 'Monitor'
          && LTIdata.render_path === 'broadcast2'
        )"
        class="lti-actions"
      >
        <v-btn
          v-if="(
            simpleDashData.primary
            && LTIdata.render_path === 'broadcast2'
          )"
          text
          id="lti-secondary"
          @click="ltiAction(simpleDashData.primarylink)"
          :disabled="simpleDashLoading"
          :loading="simpleDashLoading"
        >
          <span>{{ simpleDashData.primary }}</span>
          <v-icon
            v-if="simpleDashData.primaryicon"
            class="branded-text"
            style="padding-left: 8px"
            >{{ simpleDashData.primaryicon }}</v-icon
          >
        </v-btn>
        <v-btn
          v-if="(
            simpleDashData.primary
            && LTIdata.render_path === 'broadcast2'
          )"
          id="lti-primary"
          @click="broadcast"
          :disabled="simpleDashLoading"
          :loading="simpleDashLoading"
        >
          <span>Broadcast</span>
          <v-icon
            v-if="simpleDashData.primaryicon"
            class="text-white"
            style="padding-left: 8px"
            >{{ simpleDashData.primaryicon }}</v-icon
          >
        </v-btn>
      </div>
      <div
        v-if="
          simpleDashData.primary === 'Monitor' &&
          LTIdata.render_path === 'broadcast2'
        "
        class="lti-actions"
      >
        <v-btn
          v-if="simpleDashData.tertiary"
          text
          id="lti-secondary"
          @click="ltiAction(simpleDashData.tertiarylink)"
          :disabled="simpleDashLoading"
          :loading="simpleDashLoading"
        >
          <span>{{ simpleDashData.tertiary }}</span>
        </v-btn>
        <v-btn
          v-if="simpleDashData.secondary"
          text
          id="lti-secondary"
          @click="ltiAction(simpleDashData.secondarylink)"
          :disabled="simpleDashLoading"
          :loading="simpleDashLoading"
        >
          <span>{{ simpleDashData.secondary }}</span>
        </v-btn>
      </div>
      <!-- action buttons for linked Playlist -->
      <div
        v-if="LTIdata.render_path === 'playlist'"
        class="lti-actions"
      >
        <v-btn
          v-if="simpleDashData.primary"
          text
          id="lti-secondary"
          href="https://knowledge.playposit.com/article/284-how-to-link-a-playlist-in-your-lms#monitor-playlist"
          target="_blank"
          rel="noopener"
        >
          <span>Learn More</span>
        </v-btn>
        <v-btn
          v-if="simpleDashData.primary"
          text
          id="lti-tertiary"
          @click="ltiAction('playlistPreview')"
          :disabled="simpleDashLoading"
          :loading="simpleDashLoading"
        >
          <span>Preview</span>
        </v-btn>
        <v-btn
          v-if="simpleDashData.primary"
          id="lti-primary"
          @click="ltiAction('monitor')"
          :disabled="simpleDashLoading"
          :loading="simpleDashLoading"
        >
          <span>Monitor</span>
          <v-icon class="text-white pl-2">launch</v-icon>
        </v-btn>
      </div>

      <!-- exit grey screen-->
      <div
        v-if="(
          simpleDashData.exit
          && !hasCustomLtiDash
        )"
        class="lti-actions"
      >
        <a
          id="lti-exit"
          @click="ltiAction(simpleDashData.exit)"
          >{{ simpleDashData.exitText }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>

import {
  mapState,
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';

// Global Mixin(s):
import LottieAnimation from '@mixins/LottieAnimation/LottieAnimation.js';
import Modal from '@mixins/Modal/Modal.js'; // eslint-disable-line

// Lottie animations:
import lti13ContentMigrationAnimation from '@/assets/lottie-animations/lti13-content-migration.json';

import _ from 'lodash';

import {
  LTI13_MIGRATION_STATUSES,
  LTI_RENDER_PATHS,
  LMS_TYPES,
} from '@Constants';

import { BroadcastChannel } from 'broadcast-channel';

import {
  PlayPositBroadcastChannels,
  PlayPositBroadcastChannelEventNames,
} from '@BroadcastChannels';

export default {
  name: 'LTIGreyScreen',
  mixins: [ LottieAnimation, Modal ],
  computed: {
    ...mapState([
      'lti13Launch',
      'ltiContentMigrationFinished',
    ]),
    ...mapGetters([
      'serverURL',
      'nodeApiPrefix',
      'simpleDash',
      'simpleDashType',
      'simpleDashData',
      'simpleDashLoading',
      'learnerData',
      'instructorData',
      'designerApiPrefix',
      'playerApiPrefix',
      'LMSdata',
      'LTIclassName',
      'LTIdata',
      'LTIlaunch',
      'popoverToggles',
      'userDataLoaded',
      'phpApiPrefix',
      'school',
      'primaryAccount',
      'hasCanvasApi',
    ]),
    ...mapGetters('admin', [
      'schoolsWithChangedDefaultView',
    ]),
    ...mapGetters('instructors', [
      'playlistHash',
      'hasCustomLtiDash',
    ]),
    ...mapGetters('learners', [
      'classPicker',
      'learnersAjaxing',
      'peerReview',
    ]),
    isMSU() {
      return [2637].includes(_.get(this, 'school.id', 0));
    },
    MSUAlertMessage() {
      return 'Notice: This product is still in pilot. We cannot currently guarantee access beyond June 2026. Please use at your own discretion.';
    },
    contentMigartionConditional() {
      if (!this.lti13Launch) return false
      return !this.ltiContentMigrationFinished;
    },
  },
  methods: {
    ...mapActions([
      'unlinkBulb',
      'unlinkPlaylist',
      'checkLti1p1ContentAlreadyLinked',
      'Lti1p1ToLti1p3ContentMigration',
    ]),
    ...mapMutations([
      'handleDialogOpen',
      'setDashModal',
      'simpleDashToggle',
      'slideOut',
      'triggerSnackbar',
    ]),
    ltiAction: function(type) {
      if (type === 'learnMore') {
        if (this.LMSdata.type === LMS_TYPES.Canvas) {
          window.open('https://knowledge.playposit.com/article/220-canvas');
        } else {
          window.open('https://knowledge.playposit.com/category/219-playposit-30-in-your-lms');
        }
      }
      if (type === 'bulbUnlinkLearnMore') {
        window.open('https://knowledge.playposit.com/article/130-how-to-link-unlink-bulbs-in-lms');
      }
      if (type === 'playlistUnlinkLearnMore') {
        window.open('https://knowledge.playposit.com/article/284-how-to-link-a-playlist-in-your-lms#unlink-relink');
      }
      if (type === 'exit') {
        this.$store.commit('simpleDashToggle', { activate: false });
      }
      if (type === 'csvDownload') {
        let obj = {
          type: 'Interactions',
          bulb_id: this.LTIdata.contentId,
          section_id: this.LTIdata.section_id,
        };
        this.$store.dispatch('instructors/exportDataTable', obj);
      }
      if (type === 'unlink') {
        // not 100% sure where this comes from
        // I beleive this is triggered if you manually change the content_id after setting the link but we will need to test.
        this.setDashModal({ type: 'confirmUnlink' });
      }
      if (type === 'preview') {
        const url = `${this.nodeApiPrefix}/player_v2/?type=share&bulb_id=${this.LTIdata.contentId}&token=${this.instructorData.token}&section_id=${this.LTIdata.section_id}&lms_launch=${this.LTIlaunch}`;
        window.open(url);
      }
      if (type === 'playlistPreview') {
        const url = `${this.nodeApiPrefix}/course/${this.playlistHash}?token=${this.instructorData.token}&preview=true`;
        window.open(url);
      }
      if (type === 'unlinkOther') {
        /** Workflow:
         * link assignment A to bulb a,
         * CIM launch assignment B,
         * select bulb a,
         * unlink bulb a,
         * link bulb A to assignment B,
         * launch assignment A,
         * unlink assignement B
         **/
        let objData =
          typeof this.simpleDashData.data === 'string'
            ? JSON.parse(this.simpleDashData.data)
            : this.simpleDashData.data;
        if (objData.renderPath === LTI_RENDER_PATHS.Playlist) {
          this.unlinkPlaylist({
            playlistId: objData.contentId,
            sectionId: objData.sectionId,
            isContentItemLaunch: 1,
            unlinkOther: {
              title: `"${this.simpleDashData.title.split('"')[1]}" unlinked from "${
                this.simpleDashData.primary.split('"')[1]
              }"`,
              msg: 'Please refresh your browser to launch this assignment again in order to link the playlist.',
            },
          });
        } else {
          this.unlinkBulb({
            bulb_id: objData.contentId,
            section_id: objData.sectionId,
            render_path: objData.renderPath,
            content_item_launch: 1,
            unlinkOther: {
              title: `"${this.simpleDashData.title.split('"')[1]}" unlinked from "${
                this.simpleDashData.primary.split('"')[1]
              }"`,
              msg: 'Please refresh your browser to launch this assignment again in order to link the bulb.',
            },
          });
        }
      }
      if (type === 'linkAgain') {
        let objData = JSON.parse(this.simpleDashData.data);
        this.$store.dispatch('relinkAssignment', objData);
      }
      if (type === 'monitor') {
        //set query params and active view
        this.$store.commit('setNav', ['Classes', 'instructor']);
        this.$store.commit('instructors/resetQueryParams');

        const queryParams = {
          bulb_id: this.LTIdata.render_path !== LTI_RENDER_PATHS.Playlist ? this.LTIdata.contentId : '',
          contentId: this.LTIdata.contentId,
          section_id: this.LTIdata.section_id,
          lms_class: true,
          playlistGradebook: this.LTIdata.render_path === LTI_RENDER_PATHS.Playlist ? this.LTIdata.contentId : '',
          embed: this.hasCustomLtiDash ? true : '',
          lti13Launch: this?.lti13Launch,
          issuer: this?.LTIdata?.issuer,
        };

        this.$store.commit('instructors/setQueryParams', queryParams);
        //check render path to determine monitor page
        if (
          this.LTIdata.render_path === LTI_RENDER_PATHS.Play2
          || this.LTIdata.render_path === LTI_RENDER_PATHS.Broadcast2
        ) {
          this.$store.commit('instructors/setActiveView', ['Interactions']);
        }
        else if (this.LTIdata.render_path === LTI_RENDER_PATHS.Studentmade2) {
          if (this.LTIdata.peer_review === true) {
            this.$store.commit('instructors/setActiveView', ['Peer-Review']);
          } else {
            this.$store.commit('instructors/setActiveView', ['Learner-Made-Bulb']);
          }
        } else if (this.LTIdata.render_path === 'playlist') {
          this.$store.commit('instructors/setActiveView', ['Gradebook']);
        }

        let payload = {};
        let breadcrumb = [
          { text: 'Classes', disabled: false, payload: 'Classes' },
          { text: this.LTIclassName, payload: '' },
          { text: 'My Bulbs', payload: 'My-Bulbs' },
        ];
        this.$store.commit('updateBreadCrumbs', [ breadcrumb, payload ]);
        this.$store.commit('instructors/setGradebookBreadcrumbs', [{ text: this.LTIdata.contentName, payload: '' }]);
        //get table data, update url
        this.$store.dispatch('instructors/getTableData');
        this.$store.dispatch('instructors/updateUrl');

        setTimeout(() => {
          const monitorUrl = `${window.location.href}&token=${this.instructorData.token}&monitor=true${this?.lti13Launch ? `&lti13Launch=true` : ''}${this?.LTIdata.consumer_pk ? `&consumer_pk=${this.LTIdata.consumer_pk}` : ''}${this?.LTIdata?.issuer ? `&issuer=${this.LTIdata.issuer}` : ''}`;
          const windowRef = window.open(monitorUrl);
          windowRef.addEventListener('load', () => {
            this.legacyDashBroadcastChannel.postMessage({
              name: PlayPositBroadcastChannelEventNames.LTI_LAUNCH,
              data: this?.LTIdata,
            });
          });
        }, 1000);
      }
      if (type === 'myBulbs') {
        // for strayer school admins by default it goes to Treeview
        if (this.schoolsWithChangedDefaultView.includes(this.school.id) && this.primaryAccount === 'Admin') {
          this.$store.commit('simpleDashToggle', { activate: false });
        } else {
          this.$store.commit('setNav', ['My-Bulbs', 'instructor']);
          this.$store.commit('instructors/resetQueryParams');
          this.$store.commit('instructors/setActiveView', ['My-Bulbs']);
          //breadcrumbs
          let payload = {};
          let breadcrumb = [{ text: 'My Bulbs', disabled: false, payload: '' }];
          this.$store.commit('updateBreadCrumbs', [breadcrumb, payload]);
          //get table data, update url
          this.$store.dispatch('instructors/getTableData');
          this.$store.dispatch('instructors/updateUrl');
          this.$store.commit('simpleDashToggle', { activate: false });
        }
      }
    },
    async manageGroups() {
      // load classes so instructorDynamicToolbar Learners tab can correctly get selectedClass data
      await this.$store.dispatch('instructors/getClasses');
      // set activeView so the Vue Router can render the general "Classes" page
      this.$store.commit('setNav', ['Classes', 'instructor']);
      // set queryParams so we can render the correct section
      let queryParams = {
        bulb_id: this.LTIdata.contentId,
        contentId: this.LTIdata.contentId,
        section_id: this.LTIdata.section_id,
        lms_class: true,
      };
      this.$store.commit('instructors/setQueryParams', queryParams);
      // set instructorActiveView for the specific "Learners" tab inside of class view
      this.$store.commit('instructors/setActiveView', ['Learners']);
      // udadate what is rendered in the Toolbar Breadcrumbs area
      this.$store.commit('updateBreadCrumbs', [
        [
          {
            text: 'Classes',
            disabled: false,
            payload: 'Classes',
          },
          {
            text: this.LTIclassName,
            payload: '',
          },
        ],
        {},
      ]);
      // load learners to populate the table behind the groups slideout
      this.$store.dispatch('instructors/getTableData');
      this.$store.dispatch('instructors/updateUrl');
      this.$store.commit('simpleDashToggle', { activate: false }); // close the grey screen
      this.slideOut({
        toggle: true,
        view: 'groups',
        sectionId: this.LTIdata.section_id,
        initialTab: (
          this.hasCanvasApi
          && this.LMSdata.type === LMS_TYPES.Canvas
        ) ? 1 : 0,
      });
    },
    broadcast: function() {
      // Create code by base64_encode bulb `section_id`:
      const code = btoa(this.LTIdata.contentSectionId);
      const {
        nodeApiPrefix,
        LTIdata: {
          section_id: sectionId,
          contentId: bulbId,
        },
        instructorData: {
          token: instructorToken,
        }
      } = this;
      window.open(
        `${nodeApiPrefix}/player_v2/?section_id=${sectionId}&type=broadcast&code=${code}&bulb_id=${bulbId}&token=${instructorToken}`
      );
    },
    renderLottieAnimation() {
      this.playPositLti13ContentMigrationAnimation = this.createLottieAnimation({
        container: document.getElementById('playposit-lti13-content-migration-animation'),
        renderer: 'svg',
        animationData: lti13ContentMigrationAnimation,
        name: 'PlayPosit LTI 1.3 Content Migration',
        rendererSettings: {
          className: 'playposit-lti13-content-migration-animation-class',
        },
      });
    },
    showLti1p3MigrationContentModal() {
      this.openModal({
        applicationContext: 'lti1p3ContentMigartion',
        title: `Content Migration 🚀`,
        html: `
        <div id="playposit-lti13-content-migration-animation"></div>
        <div
          class="swal2-html-container"
          id="swal2-html-container"
          style="display: block;"
        >
          We have detected that this assignment was originally created with and LTI 1.1 tool. We are in the process of
          migrating the content to the newly configured LTI 1.3 tool.

          This shouldn't take long!
        </div>
        `,
        icon: '',
        width: '47em',
        allowEscapeKey: false,
        allowOutsideClick: false,
        focusConfirm: false,
        showCloseButton: false,
        showConfirmButton: false,
        showCancelButton: false,
        showClass: {
          popup: 'animate__animated animate__backInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__backOutDown',
        },
        customClass: {
          title: 'playposit-lti13-content-migration-title',
          container: 'playposit-lti13-content-migration-container',
        },
        didOpen: async() => {
          this.renderLottieAnimation();
          const {
            status,
            message,
          } = await this.Lti1p1ToLti1p3ContentMigration(this?.LTIdata);
          // Only display actual error messages.
          // Filter out `idle` messages, since, they aren't true errors.
          if (status === LTI13_MIGRATION_STATUSES.Error) {
            this.triggerSnackbar({
              text: message,
              color: 'red',
              customClass: 'lti-content-migration-error',
              timeout: 0,
              action_text: 'lti-content-migration-close',
              action: () => {
                this.$swal.close();
              }
            });
          }
          if (status === LTI13_MIGRATION_STATUSES.Success) {
            this.triggerSnackbar({
              text: message,
              color: 'green',
              customClass: 'lti-content-migration-success',
              timeout: 0,
              action_text: 'lti-content-migration-close',
              action: () => {
                this.$swal.close();
              }
            });
          }
        },
        willClose: () => {
          this.destroyLottieAnimation();
        },
      });
    },
     initializeLegacyDashBroadcastChannel() {
      this.legacyDashBroadcastChannel = new BroadcastChannel(PlayPositBroadcastChannels.legacyDashBroadcastChannel);
    },
  },
  watch: {
     // [ ] should we remove this?
    LTIclassName: {
      handler: function(val) {
        if (val != '') {
          if (this.simpleDashData.msg.indexOf('assigned to') >= 0) {
            this.simpleDashData.msg += `"${this.LTIclassName}"`;
          }
        }
      },
    },
  },
  created () {
    this.initializeLegacyDashBroadcastChannel();
  },
  async mounted () {
    // Setting up namespaced debugging object for our LTIGreyScreen Vue component
    window.PP.LTIGreyScreen = {
      vm: this,
    };
    if (!this.lti13Launch) return;
    if (!this?.LTIdata?.lti1p1ResourceLinkId) return;
    if (this?.LTIdata?.contentMigrated) return;
    
    const lti1p1ContentLinked = await this.checkLti1p1ContentAlreadyLinked(this?.LTIdata);
    if (!lti1p1ContentLinked) return;
    if (
      this.lti13Launch
      && this?.LTIdata?.lti1p1ResourceLinkId
      && !this?.LTIdata?.contentMigrated
    ) {
      this.showLti1p3MigrationContentModal();
    }
  },
  beforeDestroy () {
    this.legacyDashBroadcastChannel.close();
  },
}
</script>

<style lang="scss">

#lti-grey-screen {
  width: 100vw;
  height: 100vh;
  position: absolute;
}

#lti {
  width: 100%;
  height: 100%;
  background-color: #757575;
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
  overflow-y: auto;
  z-index: 1111;
}

#lti-loader {
  width: 100vw;
  height: 100vh;
  background-color: #212121;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

#lti-alert {
  width: 100%;
}

#lti-title {
  width: 100%;
  color: #fff;
  padding: 12px 48px;
  font-size: 2.5rem;
}

#lti-msu-msg {
  font-style: italic;
}

#lti-msg,
#lti-msu-msg {
  width: 100%;
  color: #fff;
  padding: 12px 48px;
  font-size: 1.7rem;
}

#lti-submsg {
  width: 100%;
  color: #fff;
  padding: 12px 48px;
  font-size: 1.3rem;
}

.lti-actions {
  width: 100%;
  height: 100px;
  display: flex;
  flex-flow: row;
  justify-content: space-around;
  align-items: center;
}

#lti-primary {
  background-color: var(--branding-active-hex) !important;
  height: 42px;
  min-width: 170px;
}

#lti-primary span {
  color: #fff;
  font-size: 1.3rem;
}

#lti-secondary,
#lti-tertiary {
  background-color: #fff;
  height: 42px;
  min-width: 170px;
}

#lti-secondary span,
#lti-tertiary span {
  color: var(--branding-active-hex) !important;
  font-size: 1.3rem;
}

#lti-exit {
  color: #fff;
  font-size: 1.3rem;
  text-decoration: underline;
}

@media only screen and (max-width: 400px) and (orientation: portrait) {
  /* For mobile: */

  #lti-title {
    padding: 8px 12px;
    font-size: 1.7rem;
  }

  #lti-msg,
  #lti-msu-msg {
    padding: 8px 12px;
    font-size: 1rem;
    font-weight: bold;
  }

  #lti-primary span {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-secondary span,
  #lti-tertiary span {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-exit {
    font-size: 14px;
    font-weight: bold;
  }
}

@media only screen and (max-width: 400px) and (orientation: landscape) {
  #lti-title {
    padding: 8px 12px;
    font-size: 1.7rem;
  }

  #lti-msg,
  #lti-msu-msg {
    padding: 8px 12px;
    font-size: 1rem;
    font-weight: bold;
  }

  #lti-primary span {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-secondary span,
  #lti-tertiary span {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-exit {
    font-size: 14px;
    font-weight: bold;
  }
}

@media only screen and (min-width: 401px) and (max-width: 800px) and (orientation: portrait) {
  #lti-title {
    padding: 8px 12px;
    font-size: 1.7rem;
  }

  #lti-msg,
  #lti-msu-msg {
    padding: 8px 12px;
    font-size: 1rem;
    font-weight: bold;
  }

  #lti-primary span {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-secondary span,
  #lti-tertiary span {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-exit {
    font-size: 14px;
    font-weight: bold;
  }
}

@media only screen and (min-width: 401px) and (max-width: 800px) and (orientation: landscape) {
  #lti-title {
    padding: 8px 12px;
    font-size: 1.7rem;
  }

  #lti-msg,
  #lti-msu-msg {
    padding: 8px 12px;
    font-size: 1rem;
    font-weight: bold;
  }

  #lti-primary span {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-secondary span,
  #lti-tertiary span {
    font-size: 14px;
    font-weight: bold;
  }

  #lti-exit {
    font-size: 14px;
    font-weight: bold;
  }
}

// Common styling for our modals
@import '@mixins/Modal/styles.scss';

.lti-content-migration-success > div > div {
  height: 100px;
}

.lti-content-migration-error > div > div {
  height: 100px;
}

.playposit-lti13-content-migration-animation-class {
  animation: fadeIn; /* referring directly to the animation's @keyframe declaration */
  width: 50% !important;
  height: 50% !important;
  margin: -41px;
}

</style>
